import { CourseEnum } from "../enums";
import { SelectListDto } from "../models";

export const SUBJECTS_FILTER_KEYS = {
  educationSystemId: "educationSystemId",
  curriculumId: "curriculumId",
  courseId: "courseId",
  stageId: "stageId",
  gradeId: "gradeId",
} as const;

export type SubjectsFilters = {
  educationSystemId: string;
  curriculumId: string;
  courseId: string;
  stageId: string;
  gradeId: string;
};

export const readSubjectsFiltersFromSearch = (search: string): SubjectsFilters => {
  const params = new URLSearchParams(search);
  return {
    educationSystemId: params.get(SUBJECTS_FILTER_KEYS.educationSystemId) || "",
    curriculumId: params.get(SUBJECTS_FILTER_KEYS.curriculumId) || "",
    courseId: params.get(SUBJECTS_FILTER_KEYS.courseId) || "",
    stageId: params.get(SUBJECTS_FILTER_KEYS.stageId) || "",
    gradeId: params.get(SUBJECTS_FILTER_KEYS.gradeId) || "",
  };
};

export const buildSubjectsSearch = (
  filters: Partial<SubjectsFilters>,
): string => {
  const params = new URLSearchParams();
  if (filters.educationSystemId) {
    params.set(
      SUBJECTS_FILTER_KEYS.educationSystemId,
      filters.educationSystemId,
    );
  }
  if (filters.curriculumId) {
    params.set(SUBJECTS_FILTER_KEYS.curriculumId, filters.curriculumId);
  }
  if (filters.courseId) {
    params.set(SUBJECTS_FILTER_KEYS.courseId, filters.courseId);
  }
  if (filters.stageId) {
    params.set(SUBJECTS_FILTER_KEYS.stageId, filters.stageId);
  }
  if (filters.gradeId) {
    params.set(SUBJECTS_FILTER_KEYS.gradeId, filters.gradeId);
  }
  return params.toString() ? `?${params.toString()}` : "";
};

export const getCourseSlug = (
  courses: SelectListDto[] | undefined,
  courseId: string,
): string => {
  const course = courses?.find((c) => c.id === courseId);
  if (!course) return CourseEnum.FIRST_COURSE;
  const name = course.value.en.toLowerCase();
  if (name === "second course") return CourseEnum.SECOND_COURSE;
  return CourseEnum.FIRST_COURSE;
};

export const getCourseIdBySlug = (
  courses: SelectListDto[] | undefined,
  slug: string,
): string => {
  if (!courses?.length) return "";
  const normalized = slug.toLowerCase();
  if (normalized === CourseEnum.SECOND_COURSE) {
    return (
      courses.find((c) => c.value.en.toLowerCase() === "second course")?.id ||
      ""
    );
  }
  return (
    courses.find((c) => c.value.en.toLowerCase() === "first course")?.id || ""
  );
};
